// Мутации компании. Создание и правка живут внутри `CompanyFormModal` (там своя
// инвалидация карточки), здесь — удаление из строки списка.
import { createEntityMutations } from '../../../shared/api/createEntityMutations.js';

import { deleteCompany, type CompanyDetail } from '../api/companies.client.js';

const companyMutations = createEntityMutations<CompanyDetail>({
  key: 'companies',
  // Удаление компании отвязывает её контакты, сделки и задачи — их списки устаревают.
  alsoInvalidate: ['contacts', 'deals', 'tasks'],
  remove: deleteCompany,
});

export const useDeleteCompanyMutation = companyMutations.useDelete;
